import { useEffect, useState } from "react";
import {
  ColumnsButton,
  ExportCsvButton,
  GridToolbarBar,
  ToolbarGroup,
  ToolbarSpacer,
  ToolTextButton,
} from "../../../../../components/ToolbarKit";
import API from "../../../../../api";
import { DataGridPro } from "@mui/x-data-grid-pro";
import {
  renderTypeCell,
  TOEstablishTheColorOfLog,
} from "../../../../../components/ImportantFunctions";
//import CircularIndeterminate from "../../../../components/circularProgress";
import { Typography, Box, Button, Tooltip } from "@mui/material";
import TriangleChartTooltip from "./TriangleStat";
import ChangeHistoryOutlinedIcon from "@mui/icons-material/ChangeHistoryOutlined";
import { dataGridStyle, palette } from "../../../../../theme";



const GROUP_BY = [
  { label: "Details", value: "dettaglio" },
  { label: "Source IP", value: "ipSorgente" },
  { label: "Destination IP", value: "ipDestinatario" },
];

// "Filter by" nell'header della tabella, con le stesse azioni (Columns, Export) delle tabelle Security.
const LeftToolbar = ({ queryType, setQueryType }) => (
  <GridToolbarBar>
    <ToolbarGroup>
      <Typography sx={{ fontSize: 13, color: "#a3a3a3", mr: 0.5 }}>Filter by</Typography>
      {GROUP_BY.map(({ label, value }) => {
        const active = queryType?.univocLogsBy === value;
        return (
          <ToolTextButton
            key={value}
            onClick={() => setQueryType({ univocLogsBy: value })}
            aria-pressed={active}
            sx={active ? { borderColor: palette.primary.main, backgroundColor: "rgba(69,144,149,0.18)" } : undefined}
          >
            {label}
          </ToolTextButton>
        );
      })}
    </ToolbarGroup>
    <ToolbarSpacer />
    <ToolbarGroup>
      <ColumnsButton />
      <ExportCsvButton />
    </ToolbarGroup>
  </GridToolbarBar>
);

const LeftTableTiresia = ({ queryType, setDetailMap, setQueryType }) => {
  const [anomaliesLog, setAnomaliesLog] = useState([]);
  const [charged, setCharged] = useState(false);

  useEffect(() => {
    setAnomaliesLog([]);
    setCharged(false);
    API.getTiresia(queryType)
      .then((res) => {
        const transformData = res.data.map((item, index) => ({
          id: index,
          ...(queryType.univocLogsBy === "dettaglio"
            ? { dettaglio: item._id }
            : {}),
          ...(queryType.univocLogsBy === "ipSorgente"
            ? { ipSorgente: item._id }
            : {}),
          ...(queryType.univocLogsBy === "ipDestinatario"
            ? { ipDestinatario: item._id }
            : {}),
          ...item,
        }));
        setAnomaliesLog(transformData);
        setCharged(true);
      })
      .catch((err) => {
        console.error(err);
        setCharged(true);
      });
  }, [queryType]);

  const columns = [
    ...(queryType.groupedQuery ||
    queryType.univocLogsBy === "dettaglio" ||
    queryType.filtered
      ? [
          {
            field: "dettaglio",
            headerName: "Detail",
            headerAlign: "center",
            flex: 1,
            minWidth: queryType.filtered ? 280 : 320,
            align: "left",
            renderCell: (params) => {
              const detail = params.value;
              const ipSorgente = params.row.ipSorgente;
              const ipDestinatario = params.row.ipDestinatario;
              return (
                <div
                  className="detail-clickable-cell"
                  style={{
                    width: "auto",
                    color: TOEstablishTheColorOfLog(detail),
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "left",
                    gap: 20,
                  }}
                >
                  {params.value}
                  {queryType.groupedQuery && (
                    <Tooltip
                      title={
                        <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", alignContent: "center" }}>
                        <TriangleChartTooltip
                          detail={detail}
                          ipSorgente={ipSorgente}
                          ipDestinatario={ipDestinatario}
                        />
                        </div>

                      }
                    >
                      <ChangeHistoryOutlinedIcon />
                    </Tooltip>
                  )}
                </div>
              );
            },
          },
        ]
      : []),
    ...(!queryType.filtered
      ? [
          {
            field: "count",
            headerName: "Count",
            headerAlign: "center",
            flex: 1,
            minWidth: 50,
            align: "center",
          },
        ]
      : []),
    ...(queryType.univocLogsBy === "dettaglio"
      ? [
          {
            field: "mapDetail",
            headerName: "MAP & DETAIL",
            headerAlign: "center",
            flex: 1,
            minWidth: 50,
            align: "center",
            renderCell: (params) => {
              return (
                <Button sx={{
                  backgroundColor: "#2d2d2d !important",
                  mt: 3,
                  mb: 2,
                  "&:hover": {
                    backgroundColor: "#eaeaea !important",
                    color: "#131C2D",
                  },
                }}
                onClick={() => {
                  setDetailMap(params.row.dettaglio)
                }}
                style={{ fontWeight: "bold" }} >MAP & DETAIL</Button>
              );
            },
          },
        ]
      : []),
    ...(queryType.groupedQuery || queryType.filtered
      ? [
          {
            field: "tipo",
            headerName: "Type",
            headerAlign: "center",
            flex: 1,
            minWidth: 100,
            align: "center",
            renderCell: renderTypeCell,
          },
        ]
      : []),
    ...(queryType.groupedQuery ||
    queryType.univocLogsBy === "ipSorgente" ||
    queryType.filtered
      ? [
          {
            field: "ipSorgente",
            headerName: "Source IP",
            headerAlign: "center",
            flex: 1,
            minWidth: 100,
            align: "center",
          },
        ]
      : []),
    ...(queryType.groupedQuery ||
    queryType.univocLogsBy === "ipDestinatario" ||
    queryType.filtered
      ? [
          {
            field: "ipDestinatario",
            headerName: "Dest IP",
            headerAlign: "center",
            flex: 1,
            minWidth: 100,
            align: "center",
          },
        ]
      : []),
    {
      field: "avg_score",
      headerName: "AVG Score",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      align: "center",
      renderCell: (params) => {
        return (
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 900,
              color:
                params.value <= 0.89
                  ? "#8963b2"
                  : params.value <= 0.98
                  ? "orange"
                  : "red",
            }}
          >
            {(params.value * 100).toFixed(2)} %
          </Typography>
        );
      },
    },
  ];

  return (
    <Box sx={{ backgroundColor: palette.background.paper, borderRadius: "15px" }}>
      <DataGridPro
        showToolbar
        slots={{ toolbar: LeftToolbar }}
        sx={[dataGridStyle, { height: "50vh" }]}
        rows={anomaliesLog}
        columns={columns}
        pagination
        loading={!charged}
        slotProps={{
          loadingOverlay: { variant: "skeleton" },
          toolbar: { queryType, setQueryType },
        }}
      />
    </Box>
  );
};

export default LeftTableTiresia;
